import { isValidPhoneNumber } from 'react-phone-number-input';
import messages from './messages';

const t = (key: any, intl: any, values: any) => {
  if (intl && intl.formatMessage) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return intl.formatMessage(messages[key], values);
  }

  return '';
};

export const required = (value: any, allValues: any, props: any) => {
  if (!value && typeof value !== 'number') {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('required', props.intl);
  }
  return undefined;
};

export const match = (field: any) => (value: any, allValues: any, props: any) => {
  if (value && value !== allValues[field]) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('match', props.intl);
  }
  return undefined;
};

export const stringLength = (length: any) => (value: any) => {
  if (value && value.length !== length) {
    return `Must be ${length} characters long`;
  }
  return undefined;
};

export const minLength = (min: any) => (value: any, allValues: any, props: any) => {
  if (value && value.length < min) {
    return props ? t('minLength', props.intl, { min }) : 'error';
  }
  return undefined;
};
export const minLength8 = minLength(8);

export const maxLength = (max: any) => (value: any, allValues: any, props: any) => {
  if (value && value.length > max) {
    return t('maxLength', props.intl, { max });
  }
  return undefined;
};
const maxLength99 = maxLength(99);

export const isAlpha = (value: any, allValues: any, props: any) => {
  if (value && /[^a-zA-Z ]/.test(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('isAlpha', props.intl);
  }
  return undefined;
};

export const containsAlpha = (value: any, allValues: any, props: any) => {
  if (value && !/[a-zA-Z]+/.test(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('containsAlpha', props.intl);
  }
  return undefined;
};

export const containsLowerAlpha = (value: any, allValues: any, props: any) => {
  if (value && !/[a-z]+/.test(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('containsLowerAlpha', props.intl);
  }
  return undefined;
};

export const containsUpperAlpha = (value: any, allValues: any, props: any) => {
  if (value && !/[A-Z]+/.test(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return props ? t('containsUpperAlpha', props.intl) : 'error';
  }
  return undefined;
};

export const minWords = (min: any) => (value: any, allValues: any, props: any) => {
  if (value && value.split(' ').length < min) {
    return t('minWords', props.intl, { min });
  }

  return undefined;
};

export const isAlphaNumeric = (value: any, allValues: any, props: any) => {
  if (value && /[^a-zA-Z0-9 ]/.test(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('isAlphaNumeric', props.intl);
  }
  return undefined;
};

export const isNumber = (value: any, allValues: any, props: any) => {
  if (value && Number.isNaN(Number(value))) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('isNumber', props.intl);
  }
  return undefined;
};

export const containsNumber = (value: any, allValues: any, props: any) => {
  if (value && !/\d+/.test(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return props ? t('containsNumber', props.intl) : 'error';
  }
  return undefined;
};

export const minNumber = (min: any) => (value: any, allValues: any, props: any) => {
  if (value && Number(value) < min) {
    return t('minNumber', props.intl, { min });
  }
  return undefined;
};

export const maxNumber = (max: any) => (value: any, allValues: any, props: any) => {
  if (value && Number(value) > max) {
    return t('maxNumber', props.intl, { max });
  }
  return undefined;
};

export const containsSpecialChars = (value: any, allValues: any, props: any) => {
  if (value && !/[+=^$*.[\]{}()?\-"!@#%&/\\,><':;/|_~`]+/.test(value)) {
    return t('containsSpecialChars', props.intl, {
      chars: '+ = ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~ `',
    });
  }
  return undefined;
};

export const isEmail = (value: any, allValues: any, props: any) => {
  if (value && !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('isEmail', props.intl);
  }
  return undefined;
};

export const isPhone = (value: any, allValues: any, props: any) => {
  if (value && !isValidPhoneNumber(value)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    return t('isPhone', props.intl);
  }
  return undefined;
};

export const isPassword = [minLength8, maxLength99, containsAlpha, containsNumber];
